// LOGO GRANDE NO HERO DA HOME, NO LUGAR DA LOGO DO CANTO (cs2580 Área Total Imóveis, 22/09/2026).
//
// O cliente pediu a logo da imobiliária na página principal, centralizada e ~4× maior, logo ACIMA
// do título do hero ("Área Total imóveis: O melhor imóvel para você"), e SEM a logo no canto
// superior esquerdo do cabeçalho. Só na home: nas páginas internas (listagens, ficha, blog) o
// cabeçalho continua com a logo — senão o site fica sem marca nenhuma nelas.
//
// Régua do tamanho: a logo do topo 3 (components/pieces/topo2) mede 60px no computador e 40px no
// celular; 4× = 240px / 160px (WelcomePieces.module.css › .logoHero).
//
// Por que allowlist: o hero 1 (WelcomePieces) serve ~480 tenants e o topo 3 outros 16 — pedido de
// um cliente sai restrito à licença que pediu (regra da casa, mesmo molde de utils/logoTenant.ts).
export const CODSITES_LOGO_NO_HERO = new Set<number>([2580]);

/** true = a home mostra a logo grande e centralizada acima do título do hero. */
export function mostraLogoNoHero(site: any): boolean {
  return CODSITES_LOGO_NO_HERO.has(Number(site?.id)) && Boolean(site?.url_logo);
}

/** true = o cabeçalho da HOME esconde a logo do canto (ela está no hero). Fora da home nada muda. */
export function escondeLogoDoTopoNaHome(site: any, caminho: string): boolean {
  return mostraLogoNoHero(site) && (caminho === '/' || caminho === '');
}
